import { Graphics } from 'pixi.js';
import { type System, ComponentStore } from '@ecs/world';
import { DEFAULT_TUNING, type Tuning } from '@game/tuning';
import type { CameraResource, PlayerHealth, TimeScaleResource, TransformComponent } from '@game/scenes/characterPrototype/types';
import { updatePlayerGraphicFill } from '@game/scenes/characterPrototype/renderUtils';

export function createGraphicsSyncSystem(
	graphics: ComponentStore<Graphics>,
	transforms: ComponentStore<TransformComponent>
): System {
	return ({ world }) => {
		const tuning = world.getResource<Tuning>('tuning') ?? DEFAULT_TUNING;
		const timescale = world.getResource<TimeScaleResource>('timescale');
		const camera = world.getResource<CameraResource>('camera');
		const playerId = world.getResource<number>('player-entity');
		const playerHealth = world.getResource<PlayerHealth>('player-health');
		const offsetY = camera ? camera.y : 0;
		const alpha = timescale ? 0.85 + 0.15 * timescale.value : 1;
		graphics.forEach((graphic, entity) => {
			const transform = transforms.get(entity);
			if (!transform) return;
			graphic.position.set(transform.x, transform.y - offsetY);
			if (playerId && playerHealth && entity === playerId) {
				const healthRatio = Math.max(0, Math.min(1, playerHealth.current / playerHealth.max));
				updatePlayerGraphicFill(graphic, healthRatio, tuning.playerSize);
				graphic.alpha = 1;
			} else {
				graphic.alpha = alpha;
			}
		});
	};
}


